import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from 'react-router-dom';

const SITE_URL = 'https://bocadelraypath.com';

const breadcrumbMap = {
  services: 'Services',
  'gi-pathology': 'GI Pathology',
  'histology-training': 'Histology Training',
  team: 'Our Team',
  contact: 'Contact Us',
  'referring-practices': 'Referring Practices',
  'privacy-policy': 'Privacy Policy'
};

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // No breadcrumb trail on the homepage, and none on an unmatched path either —
  // that's the 404 page, which is `noindex`; emitting a BreadcrumbList for a
  // URL that doesn't correspond to a real page would contradict that signal.
  if (pathnames.length === 0 || !(pathnames[0] in breadcrumbMap)) {
    return null;
  }

  const crumbs = pathnames.map((name, index) => {
    const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
    return {
      name: breadcrumbMap[name] || name,
      path: routeTo
    };
  });

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
      ...crumbs.map((crumb, index) => ({
        '@type': 'ListItem',
        position: index + 2,
        name: crumb.name,
        item: `${SITE_URL}${crumb.path}`
      }))
    ]
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      </Helmet>
      <nav className="breadcrumbs" aria-label="Breadcrumb">
        <ol>
          <li>
            <Link to="/">Home</Link>
          </li>
          {crumbs.map((crumb, index) => {
            const isLast = index === crumbs.length - 1;
            return (
              <li key={crumb.path}>
                {isLast ? (
                  <span aria-current="page">{crumb.name}</span>
                ) : (
                  <Link to={crumb.path}>{crumb.name}</Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumbs;
